import { Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { DailyDosingService } from '../../../services/daily-dosing.service';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { MatIconModule } from "@angular/material/icon";
import { UpdateSalisburyDosingComponent } from './update-salisbury-dosing/update-salisbury-dosing.component';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-salisbury-dosing',
  imports: [CommonModule, MatTableModule, MatIconModule, MatButtonModule],
  templateUrl: './salisbury-dosing.component.html',
  styleUrl: './salisbury-dosing.component.scss'
})
export class SalisburyDosingComponent implements OnInit {

  displayedColumns = [
    'actions', 'id', 'tankName', 'datecaptured', 'height', 'volume',
    'loads', 'other', 'percent_SAD', 'percent_NAD', 'sadGalons', 'nadGalons'
  ];

  dataSource = new MatTableDataSource<any>;
  @ViewChild(MatSort) sort!: MatSort;
  private destroyRef = inject(DestroyRef);

  //Default Values
  readonly SITE_ID = 6;

  constructor(private _dailyDosingService: DailyDosingService, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.getDailyDosingSalisbury();
  }

  private getDailyDosingSalisbury(): void {
    this._dailyDosingService.getDailyDosingSalisbury(this.SITE_ID).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (response: any[]) => {
        this.dataSource.data = [...response];
        this.dataSource.sort = this.sort;
      }
    })
  }

  openEditForm(row: any): void {
    console.log('Edit row:', row);
    const dialogRef = this.dialog.open(UpdateSalisburyDosingComponent, {
      width: '800px',
      maxWidth: '800px',
      maxHeight: '90vh',
      data: {
        loads: row.loads,
        other: row.other,
        id: row.id,
        tank: row.tankName,
        dtc: row.datecaptured
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getDailyDosingSalisbury();
      }
    });
  }

}
